// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__33wbI","right":"styles_right__1u5r9"};